import React from "react";
import { FormattedMessage } from "react-intl";

// @mui/material components
import Grid from "@mui/material/Grid";

// core components
import HeaderContainer from "components/List/components/HeaderContainer";

// Column widths are kept in sync with BrandLine so headers line up with values.
function TableHeader() {
    return (
        <HeaderContainer>
            <Grid item container xs={6} alignItems={"center"}>
                <Grid item>
                    <FormattedMessage id={"brand.table.header.name"} />
                </Grid>
            </Grid>
            <Grid
                item
                container
                xs={6}
                columnSpacing={2}
                justifyContent={"flex-end"}
                flexWrap={"nowrap"}
            >
                <Grid item sx={{ width: "130px", textAlign: "center" }}>
                    <FormattedMessage id={"brand.table.header.products"} />
                </Grid>
                <Grid item sx={{ width: "70px", textAlign: "center" }}>
                    <FormattedMessage id={"list.header.status"} />
                </Grid>
                <Grid item sx={{ width: "100px" }}>
                    <FormattedMessage id={"list.header.date"} />
                </Grid>
                <Grid item sx={{ width: "60px" }}>
                    <FormattedMessage id={"list.header.hour"} />
                </Grid>
                <Grid item sx={{ width: "70px" }}>
                    <FormattedMessage id={"list.header.actions"} />
                </Grid>
            </Grid>
        </HeaderContainer>
    );
}

export default TableHeader;
